export enum TradeStatus {
  CORRECT_DEAL = 1,
  CORRECTED_DEAL = 2,
  SUSPICIOUS_DEAL = 3,
  WRONG_DEAL = 4,
  BLOCK = 5,
}

export const TradeStatusLabels: Record<TradeStatus, string> = {
  [TradeStatus.CORRECT_DEAL]: 'صفقة صحيحة',
  [TradeStatus.CORRECTED_DEAL]: 'صفقة تم تصحيحها',
  [TradeStatus.SUSPICIOUS_DEAL]: 'مشكوك فى صحتها',
  [TradeStatus.WRONG_DEAL]: 'صفقة خاطئة',
  [TradeStatus.BLOCK]: 'بلوك',
};

export const TradeStatusMap = Object.entries(TradeStatusLabels).reduce(
  (acc, [key, label]) => {
    const numericKey = Number(key);
    if (!isNaN(numericKey)) {
      acc[label] = numericKey;
    }
    return acc;
  },
  {} as Record<string, number>
);
